const autoNgTemplateLoaderTemplate1 = require('./logs.html');

angular.module('portainer.kubernetes').component('kubernetesStackLogsView', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'KubernetesStackLogsController',
  controllerAs: 'ctrl',
  bindings: {
    $transition$: '<',
  },
});
